import {
  STATUS_FILTER_LABELS,
  type ResourceStatus
} from '@/shared/lib/status'

/* A biblioteca só distingue três estados: disponível, concluído e bloqueado.
   Não tem `progress` (documento não tem progresso parcial), nem `expired`, nem
   `danger`. Antes deste arquivo os ids eram em português (`todos`,
   `disponiveis`) e viviam inline no hook — fora do vocabulário de todas as
   outras listagens. */
export type LibraryFilterId =
  | 'all'
  | Extract<ResourceStatus, 'available' | 'success' | 'locked'>

export const LIBRARY_FILTERS: { id: LibraryFilterId; label: string }[] = [
  { id: 'all', label: 'Todos' },
  { id: 'available', label: STATUS_FILTER_LABELS.available },
  { id: 'success', label: STATUS_FILTER_LABELS.success },
  { id: 'locked', label: STATUS_FILTER_LABELS.locked }
]
